/* ⚛ REACT */
import {useEffect, useState} from "react";

/* 🎨 STYLES */
import { Container, RowContainer, AlarmText, NumberInput } from "./styles";

const AlarmsComand = ({Alarms, addComand, changeAlarms}) =>{
    const [alarmHH, setAlarmHH] = useState(null);
    const [alarmLL, setAlarmLL] = useState(null);
    const [alarmH, setAlarmH] = useState(null);
    const [alarmL, setAlarmL] = useState(null);

    const ComandConstructor = (comand, value, oldvalue, childName, key)=>{
        let name = Alarms.name+'/'+childName
        addComand([comand, value], oldvalue, name, key);
    }

    useEffect(()=>{
        if(Alarms.alarmLL){
            setAlarmLL(Alarms.alarmLL.valor)
            setAlarmL(Alarms.alarmL.valor)
        }
        if(Alarms.alarmHH){
            setAlarmHH(Alarms.alarmHH.valor)
            setAlarmH(Alarms.alarmH.valor)
        }
    },[Alarms])


    return (
        <Container>
            {Alarms.alarmHH ?
                <RowContainer>
                    <AlarmText> Alarme HH</AlarmText>
                    <NumberInput 
                    type='number'
                    onBlur={()=>ComandConstructor(Alarms.alarmHH.id, alarmHH, Alarms.alarmHH.valor, 'AlarmHH', 'alarmHH')} 
                    value={alarmHH !==null ? alarmHH : 'SD'} onChange={(e) => setAlarmHH(e.target.value)}/>

                    <NumberInput 
                    type='number'
                    onBlur={()=>ComandConstructor(Alarms.alarmH.id, alarmH, Alarms.alarmH.valor, 'AlarmH', 'alarmH')} 
                    value={alarmH !==null ? alarmH : 'SD'} onChange={(e) => setAlarmH(e.target.value)}/>
                    <AlarmText> Alarme H</AlarmText>
                </RowContainer>
                :
                <></>
            }
            {Alarms.alarmLL ?
                <RowContainer>
                    <AlarmText> Alarme LL</AlarmText>
                    <NumberInput 
                    type='number'
                    onBlur={()=>ComandConstructor(Alarms.alarmLL.id, alarmLL, Alarms.alarmLL.valor, 'AlarmLL', 'alarmLL')}
                    value={alarmLL !== null ? alarmLL : 'SD'} onChange={(e) => setAlarmLL(e.target.value)}/>

                    <NumberInput 
                    type='number'
                    onBlur={()=>ComandConstructor(Alarms.alarmL.id, alarmL, Alarms.alarmL.valor, 'AlarmL', 'alarmL')}
                    value={alarmL !== null ? alarmL : 'SD'} onChange={(e) => setAlarmL(e.target.value)}/>
                    <AlarmText> Alarme L</AlarmText>
                </RowContainer>
                :
                <></>
            }

        </Container>
    );
}

export default AlarmsComand;